import { ConfigObj, CssModifiers } from '../utils'

const defaultOpts = {
    contentId: 'ps-video-transcript__content',
    buttonClass: 'ps-video-transcript__button',
    modifier: 'm-video-transcript-closed',
    button: 'View Transcript',
    isClosed: false,
    defaultStateOpen: false
}

export default class Transcript {
    constructor($el, opts) {
        this.$el = $el
        this.options = ConfigObj.merge(defaultOpts, opts)
    }

    /**
     * Initializes the class
     */
    init() {
        this.$content = document.querySelector(`#${this.options.contentId}`)
        let $existingAnchors = this.$el.getElementsByClassName(this.options.buttonClass)
        if ($existingAnchors.length === 0) {
            let $anchor = document.createElement('a')
            $anchor.innerText = this.options.button
            $anchor.classList.add(this.options.buttonClass)
            this.$el.prepend($anchor)
            this.isClosed = this.options.isClosed
            this.$el.setAttribute('aria-controls', this.options.contentId)
            this.addEventListeners()
            if (!this.options.defaultStateOpen) {
                this.toggle()
            }
        }
    }

    /**
     * Toggle all concerning element states and content
     */
    toggle() {
        // Toggle the toggle status
        this.isClosed = !this.isClosed
        this.toggleState()
    }

    /**
     * Toggles the the state of the targeted content and handler
     */
    toggleState() {
        this.$el.setAttribute('aria-expanded', !this.isClosed)
        this.$content.setAttribute('aria-hidden', this.isClosed)
        CssModifiers.toggle(this.$el, this.isClosed, this.options.modifier)
    }

    /**
     * Binds event handlers to events
     */
    addEventListeners() {
        this.$el.addEventListener('click', this.toggle.bind(this))
    }
}



// WEBPACK FOOTER //
// ./js/modules/Transcript.js